let api = {};

const pre_v1 = "/api/v1";
const pre_v2 = "/api/e1";
const pre_v3 = "/api/v2g";
// const pre_v3 = "/apiL"
// 登录
api.login = "/api/login";
api.logout =  '/api/logout'

// 配置项
api.configType = pre_v1 + "/config/type";

//充电桩型号
api.pileType ={
    detail: pre_v1 + "/piletype",
    list: pre_v1 + "/piletype/page",
    add: pre_v1 + "/piletype/add",
    edit: pre_v1 + "/piletype/edit",
}

// 区域省市区
api.areaList = pre_v1 + "/area?pageNum=0&pageSize=9999";
// user
api.user = {
    list: pre_v1 + "/user",
    add: pre_v1 + "/user/add",
    edit: pre_v1 + "/user/edit",
    supplierusercheck: pre_v1 + "/user",
    currentUserInfo: pre_v1 + "/user/info/current", //获取当前用户信息
    cust: pre_v1 + "/cust",
    userPwdReset: pre_v1 + "/user/userPwdReset",
    saasList: pre_v1 +'/dealer/user/list',
    // 根据运营商查询角色列表
    corpList: pre_v1 + '/role/corp/list',
};

api.menu = {
    allList: pre_v1 + "/menu/list",
};
// role
api.role = {
    list: pre_v1 + "/role",
    add: pre_v1 + "/role/add",
    edit: pre_v1 + "/role/edit",
    listmenu: pre_v1 + "/role/listmenu",
    allrole: pre_v1 + "/role/list",
    saasList: pre_v1 +'/dealer/role/list',
};

api.config = {
    list: pre_v1 + "/config/list",
    config: pre_v1 + "/config",
};

//仪表盘
api.dashboard = {
    pileandorderdto: pre_v1 + "/dashboard/pileandorderdto",
    leftorderdto: pre_v1 + "/dashboard/leftorderdto",
    dayorderdto: pre_v1 + "/dashboard/dayorderdto",
    monthtrend: pre_v1 + "/dashboard/monthtrend",
    daytrend: pre_v1 + "/dashboard/daytrend",
    middlestations: pre_v1 + "/dashboard/middlestations",
    abnormalCount: pre_v1 + "/dashboard/abnormalCount",
    processingOrder: pre_v1 + "/pileorder/processingOrder",
    handlerOrder: pre_v1 + "/pileorder/handlerOrder",
    dashboardlist:pre_v1 + "/dealer/dashboardlist",
    dashboardPileorder:pre_v1 + "/pileorder/dashboard"
};
//充电日志
api.pilerecordhistory = {
    page: '/PILEHOME/api/pilerecordhistory/page',
    export: '/PILEHOME/api/pilerecordhistory/export'
}
//广汽充电桩
api.chargingpile = {
    list: '/PILEHOME/api/pile/page',
    type: '/PILEHOME/api/piletype/list',
    edit: '/PILEHOME/api/pile/edit',
    findonebyid: '/PILEHOME/api/pile/info',
    record: '/PILEHOME/api/pileorder/page',
    dealer: '/PILEHOME/api/dealer/list',
    config: '/PILEHOME/api/sysconfig/findbytype',
    typeDetail: '/PILEHOME/api/piletype/info',
    pilestation: '/PILEHOME/api/pilestation/list',
    personRecord: '/PILEHOME/api/pileorder/page',
    statusHistory: '/PILEHOME/api/pilestautshistory/page',
    witricity: '/PILEHOME/api/custpile/witricity/page',
    allowapplication: '/PILEHOME/api/custpile/witricity/allowapplication',
    rejustapplication: '/PILEHOME/api/custpile/witricity/rejustapplication',
    cancelbind: '/PILEHOME/api/custpile/witricity/cancelbind'
};
//充电桩
api.pile = {
    list: pre_v1 + "/pile/pilepage",
    pileEdit: pre_v1 + "/pile",
    pile: pre_v1 + "/pile/pagePileDto",
    //充电记录
    pileorder: pre_v1 + "/pileorder/pilecode",
    //维修
    pilerepair: pre_v1 + "/pilerepair",
    //用户反馈列表
    findByNo: pre_v1 + "/pilerepair/findByNo",
    //故障记录
    pileWarn: "/api/m1/pileWarn/page2",
    //故障备注
    warn: "/api/m1/pileWarn/edit",
    dealer: pre_v1 + "/dealer/list",
    type: pre_v1 + "/piletype/list",
    pileCharge: pre_v1 + "/pilecharge/list",
    findByPileCode: pre_v1 + "/pile/findByPileCode",
    //解绑
    unBindPile: pre_v1 + "/custpile/unBindPile",
    updatePileDetail: pre_v1 + "/pile/updatePileDetail",
    findById: pre_v1 + "/pile/findById",
    exportPile: pre_v1 + "/pile/exportPileDto",
    findPileCodeList: pre_v1 + "/pile/findPileCodeList",
    getSite: pre_v1 + '/pilestation/listZdStation',//站点查询

    // 运维备注
    getDevOps: pre_v1 + '/pileRepairHistory/page', // 运维查询
    addDevOps: pre_v1 + '/pileRepairHistory/add', // 新增运维
    delDevOps: pre_v1 + '/pileRepairHistory/delete', // 删除运维
    editDevOps: pre_v1 + '/pileRepairHistory/edit', // 编辑运维
};

//充电站
api.pilestation = {
    pilestation: pre_v1 + "/pilestation",
    list: pre_v1 + "/pilestation/list",
    rpt: pre_v1 + "/pilestation/rpt",
    findno: pre_v1 + "/pilecharge/findno",
    //根据充电网点找出的充电记录
    record: pre_v1 + "/pilestation/dealerstrategyrecord",
    //根据充电网点找出的账单
    bill: pre_v1 + "/pilestation/exportbillpdf",
    //导出
    export: pre_v1 + "/pilestation/exportbill",
    addpile: pre_v1 + "/pilestation/addpiletostation",
    delpile: pre_v1 + "/pilestation/deleteppilefromstation",
    delAppImg: pre_v1 + "/pilestation/deleteappimgs",
    pilelist: pre_v1 + "/pile/list",
    rptfrom: pre_v1 + "/pilestation/rptfrom",
    rptchart: pre_v1 + "/pilestation/rptchart",
    uploadFile: pre_v1 + '/pilestation/uploadFile',
    changeStationState: pre_v1 + '/pilestation/nullify',
    delPile: pre_v1 + '/pilestation',

    // 占位费
    occupyFee: pre_v1 + '/occupyFee/findByNo', // 占位查询（点击编辑）
    editSeat: pre_v1 + '/occupyFee/edit', // 编辑保存

    // 电表导出
    exportByStation: pre_v1 + '/ammeterFeeRecord/exportByStation', // 电表导出
    // exportByStation: pre_v1 + '/postageDetail/chaegeExpense', //
    // 电站导出
    stationExport: pre_v1 + '/pilestation/export',
    // 合同
    contractAdd: pre_v1 + '/stationcontract/add',
    getContract: pre_v1 + '/stationcontract/stationNo',
    contractEdit: pre_v1 + '/stationcontract/edit',

    // 资费日志
    pileChargeLog: pre_v1 +'/operationLog/pileChargeOperationLog',
    // 电站合同日志
    stationContractLog:pre_v1 +'/operationLog/stationContractOperationLog',
    // 站点折扣日志
    stationDiscountLog:pre_v1 +'/operationLog/stationDiscountOperationLog',
    // 查找分润
    checkProfit:pre_v1 +'/profitSettleRecord/checkProfit',

    // ZD-BOX 分页查询未绑定储能设备
    findByNo: pre_v3 + '/pileStationEnergyPoint/findUnBindPage',
    // ZD-BOX 查询站点已绑定储能设备
    findByStationNo: pre_v3 + '/pileStationEnergyPoint/findBindListByStationId',
    // ZD-BOX 站点绑定
    stationBind: pre_v3 + '/pileStationEnergyPoint/addBindEnergyPoint',
    // ZD-BOX 站点解绑
    stationUnBind: pre_v3 + '/pileStationEnergyPoint/deleteBindEnergyPoint',

    // ZD-BOX 设备列表（分页）
    getDeviceList: pre_v3 + '/energyPoint/pageVo',
    // ZD-BOX 根据 id 查询
    getDeviceById: pre_v3 + '/energyPoint/findVoById/',
    // ZD-BOX 新增或者更新
    addDevice: pre_v3 + '/energyPoint/addOrUpdateByDto',
    // ZD-BOX 设备类型列表(下拉菜单)
    getDeviceType: pre_v3 + '/energyPointType/findDisplayList',
    // ZD-BOX 新增设备类型
    addDeviceType: pre_v3 + '/energyPointType',
    // ZD-BOX设备类型列表(分页)
    getDeviceTypeList: pre_v3 + '/energyPointType',
};

//客户管理
api.cust = {
    pagecust: pre_v1 + "/cust/pagecust",
    cust: pre_v1 + "/cust/findbyid",
    addupdatecust: pre_v1 + "/cust/addupdatecust",
    targetremark: pre_v1 + "/cust/targetremark",
    custwalletlist: pre_v1 + "/custwalletlist",
    addtarget: pre_v1 + "/cust/addtarget",
    allDealer: pre_v1 + "/dealer",
    chargeCardList: pre_v1 + "/chargeCardList",
    //充值退款
    addCardList: pre_v1 + "/chargeCardList/addCardList",
    editCardList: pre_v1 + "/chargeCardList/editCardList",
    exportCustList: pre_v1 + "/cust/exportCustList",
    findCustPhoneList: pre_v1 + "/cust/findCustPhoneList",
    addInvoicing: pre_v1 + '/custInvoicing/add',//新增开票
    getInvoicingList: pre_v1 + '/custInvoicing/page',//开票记录查询
    page: pre_v1 + '/stationdiscount/page',//折扣列表
    addDiscount:  pre_v1 +'/stationdiscount/add',//折扣添加
    editDiscount: pre_v1 + '/stationdiscount/edit',//折扣编辑
    delDiscount: pre_v1 + '/stationdiscount/',//折扣删除
    getDiscount: pre_v1 + '/stationdiscount/',//获取折扣详情
    pagelog: pre_v1 + '/stationdiscountrecord/page',//详情列表
    export: pre_v1 + '/stationdiscount/export'//详情列表
};

//订单管理
api.order = {
    pileorder: pre_v1 + "/pileorder",
    getDtoList: pre_v1 + "/pileorder/getDtoList",
    getDtoPageInfo: pre_v1 + "/pileorder/getDtoPageInfo",
    dealorderreply: pre_v1 + "/pileOrderReply/dealorderreply",
    updatechargestep: pre_v1 + "/pileorder/updatechargestep",
    updateRemark: pre_v1 + "/pileorder/updateRemark",
    exportOrderList: pre_v1 + "/pileorder/exportOrderList",
    findType: pre_v1 + "/pileorder/findStationType",
    findStation: pre_v1 + "/pileorder/findStation",

    // 占位订单管理
    getSeatList: pre_v1 + '/pileorder/page',
    // 占位订单详情
    getSeatDetail: pre_v1 + '/pileorder/getPileOrderWebDetailDto',
    // 处理占位订单
    dealWithSeatOrder: pre_v1 + '/pileorder/handleOccpuy',
    // 占位处理详情
    getseatOrderDetail: pre_v1 + '/pileorder/occpuyHandelInfo',
    // 占位订单管理 导出
    exportSeatOrder: pre_v1 + '/pileorder/exportOccpuyList',
    chargeRecords:pre_v1 + '/pileChargeRecord/chargeRecords'
};

// 运营结算
api.operatorSettlement={
    // 导出
    dtoListSummaryExport:pre_v1 + '/pileorder/dtoListSummaryExport',
    // 查询
    getDtoListSummary:pre_v1+'/pileorder/getDtoListSummary',
    // 运营商
    getDealList: pre_v1 + '/dealer/getDealList',
    // 站点
    list: pre_v1 + '/pilestation/list',
    getDtoPageInfo: pre_v1 + "/pileorder/getDtoPageInfo",
}

//运营商管理
api.dealer = {
    list: pre_v1 + "/dealer/managepage",
    allList: pre_v1 + "/dealer/list",
    dealer: pre_v1 + "/dealer",
    addbank: pre_v1 + "/dealer/addbank",
    editbank: pre_v1 + "/dealer/editbank",
    editattach: pre_v1 + "/dealer/editattach",
    removeattach: pre_v1 + "/dealer/removeattach",
    addattach: pre_v1 + "/dealer/addattach",
    removebank: pre_v1 + "/dealer/removebank",
    addpiletostation: pre_v1 + "/pilestation/addpiletostation",
    updstation: pre_v1 + "/dealer/updstation",
    edit: pre_v1 + "/dealer/edit",
    add: pre_v1 + "/dealer/add",
    rptchart: pre_v1 + "/dealer/detail/rptchart",
    rpt: pre_v1 + "/dealer/detail/rpt",
    rptinfo: pre_v1 + "/dealer/detail/rptinfo",
    // custlinedata: pre_v1 + '/cust/findByCreateTime',
    rptform: pre_v1 + "/dealer/detail/rptform",
    getDealList: pre_v1 + "/dealer/getDealList",
    findByDealNo: pre_v1 + "/dealelistStationByDealr/accounts/findByDealNo",
};

//财务管理
api.finance = {
    calcpage: pre_v1 + "/dealer/accounts/calcpage",
    revieworders: pre_v1 + "/pileorder/revieworders",
    checkorders: pre_v1 + "/pileorder/checkorders",
    cashOut: pre_v1 + "/cashOut/findCashList",
    updateCashout: pre_v1 + "/cashOut/updateCashout",
    powerStationStatement: pre_v1 + '/dealer/powerStationStatement',
    export: pre_v1 + '/dealer/export',
    list: pre_v1 + '/pileorder/accounts',

    // 充电桩报表
    getpileReport: pre_v1 + '/pileorder/getCurrentMonthOrder',
    // 充电桩报表 - 导出
    exportPileReport: pre_v1 + '/pileorder/exportCurrentMonthOrder',
};

//服务记录
api.feedback = {
    serviceFeedback: pre_v1 + "/serviceFeedback",
    add: pre_v1 + "/serviceFeedback/add",
    edit: pre_v1 + "/serviceFeedback/edit",
};

//移动端管理
api.mobile = {
    banner: pre_v1 + "/banner",
    edit: pre_v1 + "/banner/notice/edit",
    add: pre_v1 + "/banner/notice/add",
    findList: pre_v1 + "/banner/notice/findList",
};
api.openScreen = {
    banner: pre_v1 + "/banner",
    edit: pre_v1 + "/banner/openScreen/edit",
    add: pre_v1 + "/banner/openScreen/add",
    findList: pre_v1 + "/banner/openScreen/findList",
};
api.banner = {
    banner: pre_v1 + "/banner",
    edit: pre_v1 + "/banner/mobile/edit",
    add: pre_v1 + "/banner/mobile/add",
    statusedit: pre_v1 + "/banner/mobile/statusedit",
    findList: pre_v1 + "/banner/mobile/findList",
};

//h5 api
api.h5 = {
    chargeCards: pre_v1 + "/app/chargeCard/chargecardList",
    consumption: pre_v1 + "/app/chargecard/pileorderList",
    rangeList: pre_v1 + "/app/chargecard/stationList",
    reChargeList: pre_v1 + "/app/chargecard/chargeList",
    exchangeCards: pre_v1 + "/app/chargeCard/exchangeCard",
};

//推送日志
api.push = {
    page: "/api/m1/pushrecord/page",
};
//活动管理
api.serviece = {
    add: pre_v2 + "/activity/saveActivity", //发布活动/URL导入
    list: pre_v2 + "/activity/getActivityList", //列表
    change: pre_v2 + "/activity/updateActivityStatus", //活动下架,发布
    del: pre_v2 + "/activity/", //删除
    edit: pre_v2 + "/activity/updateActivity", //编辑确认
    upImage: pre_v2 + "/attachment/saveFile", //上传图片
    findInfo: pre_v2 + "/activity/findInfoById/", //回收站详情
};
api.commodity = {
    list: pre_v2 + "/commodity", //列表
    up: pre_v2 + "/commodity/put", //商品上架
    down: pre_v2 + "/commodity/offCommodity", //商品下架
    file: pre_v2 + "/attachment/saveFile", //附件上传
    delFile: pre_v2 + "/attachment/", //删除附件
    export: pre_v2 + "/commodity/export", //导出文件
};
api.massaage = pre_v2 + '/warnmsg'

// 对账
api.reconciliation = {
    page: pre_v1 + "/reconciliation/page",
    reconciliationExport: pre_v1 + "/reconciliation/reconciliationExport",
}
api.reconciliationTask = {
    add: pre_v1 + "/reconciliationTask/add",
    page: pre_v1 + "/reconciliationTask/page",
    findFlag: pre_v1 + "/reconciliationTask/findFlag",
    findByCorpNo: pre_v1 + "/reconciliationTask/findByCorpNo",
}
api.chargingLog = {
    chargingSerch: pre_v1 + "/pileRecord/page",//充电日志查询
    chargingExport: pre_v1 +"/pileRecord/export",//导出
    chargingSelect: pre_v1 + "/pileRecord/findbytype"//下拉框
}
// 分润
api.profitSettleRecord={
    list:pre_v1 +'/profitSettleRecord/list',
    page:pre_v1 +'/profitSettleRecord/page',
    add:pre_v1 +'/profitSettleRecord/add',
    edit:pre_v1 +'/profitSettleRecord/edit',
    del:pre_v1 +'/profitSettleRecord/delete',
    export:pre_v1 +'/profitSettleRecord/export'
}
// 电表
api.ammeterFeeRecord={
    page:pre_v1 +'/ammeterFeeRecord/page',
    add:pre_v1 +'/ammeterFeeRecord/add',
    edit:pre_v1 +'/ammeterFeeRecord/edit',
    del:pre_v1 +'/ammeterFeeRecord/delete',
    export:pre_v1 +'/ammeterFeeRecord/export',
    listElecName:pre_v1 +'/ammeterFeeRecord/listElecName',
    // 本月，上月，上上月
    month: pre_v1 + '/ammeterFeeRecord/monthVal',

    // 电表总表 - 导出
    pileTotalExport: pre_v1 + '/ammeterFeeRecord/exportByStationNew',
    // 电表总表 - 导入
    pileTotalImport: pre_v1 + '/ammeterFeeRecord/importExcel',
    pileTotalImport2: pre_v1 + '/ammeterFeeRecord/importExcel2',
    // 电站
    pageByStation: pre_v1 + '/ammeterFeeRecord/pageByStation',
    // 电表总表 --导出
    exportByStation2: pre_v1 + '/ammeterFeeRecord/exportByStation2',
}
// 电站
api.pileStation={
    page:pre_v1 +'/dealer/pileStationStatisPage',
    del:pre_v1 +'/dealer/pileStationStatisDelBatch',
    StatisBatch:pre_v1 +'/dealer/pileStationStatisBatch',
    StatisFilt:pre_v1 +'/dealer/pileStationStatisFilt',
    export:pre_v1 +'/dealer/pileStationStatisExport',
    listStationByDeal:pre_v1 +'/dealer/listStationByDeal'
}
// 开票
api.Billing={
    // 分页查询
    page2:pre_v1+'/custInvoicing/page2',
    // 开票详情
    findByNo:pre_v1+'/custInvoicing/findByNo',
    // 审核
    examine:pre_v1+'/custInvoicing/examine',
    // 批量审核
    examineList:pre_v1+'/custInvoicing/examineList',
    // 审核
    requestBill:pre_v1+'/wechat_app/requestBill',
    // 批量查询
    queryBills:pre_v1+'/wechat_app/queryBills',
    //  查询 昨日，今日 开票信息
    queryBillInfo: pre_v1+'/custInvoicing/findByCreateTime',
}
api.invoicingOrderFlow={
    getDtoList:pre_v1+'/pileorderandcustinvoicing/getDtoList',
    exportList:pre_v1+'/pileorderandcustinvoicing/exportList'
}
// 运维管理

api.operationManagement = {
    page:pre_v1+'/pileEditHistory/page',
    recordPage:pre_v1+'/yunweiOperationRecords/page',
    export:pre_v1+'/pileEditHistory/export',
}
// 下载中心
api.downloadCenter ={
    page: pre_v1 + '/downloadCenter/page'
}
api.operationRecords = {
    page: pre_v1 + '/operationLog',
    export: pre_v1 + '/operationLog/export',
}
// 站点运营
api.siteOperations ={
    getDtoList:pre_v1 + '/siteOperations/getDtoList'
}

export default api;
